import { render } from "./ThirdParty.vue?vue&type=template&id=96d35d82"
import script from "./ThirdParty.vue?vue&type=script&lang=js"
export * from "./ThirdParty.vue?vue&type=script&lang=js"

import "./ThirdParty.vue?vue&type=style&index=0&id=96d35d82&lang=css"
script.render = render

export default script